import React from "react";

import ItemScrollVariant from "../ItemScrollVariant";
import MultiCarousel from "../MultiCarouselElements/MultiCarousel";
import MultiCarouselArrows from "../MultiCarouselElements/MultiCarouselArrows";

const ItemSlider = ({ items, cssBlock }) => {
    const itemCount = items.length;
    const showGutterDesktop = itemCount > 3 ? 20 : 0;
    const showGutterTablet = itemCount > 2 ? 20 : 0;

    const responsive = {
        desktop: {
            breakpoint: { max: 9999, min: 1024 },
            items: 3,
            slidesToSlide: 3,
            partialVisibilityGutter: showGutterDesktop
        },
        tablet: {
            breakpoint: { max: 1023, min: 640 },
            items: 2,
            slidesToSlide: 2,
            partialVisibilityGutter: showGutterTablet
        },
        mobile: {
            breakpoint: { max: 639, min: 0 },
            items: 2,
            slidesToSlide: 2,
            partialVisibilityGutter: 20
        }
    };

    const showNextItem = items.length > 1;

    const settings = {
        swipeable: true,
        draggable: false,
        showDots: false,
        responsive: responsive,
        containerClass: `${cssBlock}__slider-container`,
        itemClass: `${cssBlock}__slider-item`,
        keyBoardControl: true,
        infinite: false,
        arrows: false,
        customButtonGroup: <MultiCarouselArrows cssBlock={cssBlock} />,
        renderButtonGroupOutside: true,
        partialVisible: showNextItem
    }
    const sortItems = (a, b) => {
        if (a.isActive === b.isActive) return 0;
        else return a.isActive ? -1 : 1;
    };

    const children = (items) => {
        return (
            items.sort(sortItems).map((item, index) => (
                <ItemScrollVariant item={item} index={index} key={index} />
            ))
        )
    };
    return (
        <MultiCarousel settings={settings} children={children(items)} items={items} cssBlock={cssBlock} />
    );
};
export default ItemSlider;